export default __webpack_public_path__ + "static/IN-8015_4-2mm_lense_day_zoom-8b31deab55648c26b5d0978d47cee69f.webp";